//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'Images',

  props: {
    images: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      CDN: process.env.CDN,
      target: null,
      activeImageId: null,
    };
  },

  computed: {
    imageItems() {
      // real size image
      return this.images.map(
        (imageId) => `${this.CDN}/scene/scene_image_${imageId}_big.jpg`,
      );
    },
  },
};
